export default {
  "hierarchy": {
    "popup": [
      "radioButton-popup"
    ],
    "twoFactorMethodRadio": [
      "radioButton-twoFactorMethodRadio"
    ],
    "mobileUserNavBarNested": [
      "radioButton-mobileUserNavBarNested"
    ],
    "none": [
      "radioButton-none"
    ],
    "pairing": [
      "radioButton-pairing"
    ],
    "testradio": [
      "radioButton-testradio"
    ]
  },
  "props": {
    "default": {
      "iconOn": "fa fa-circle fa-fw"
    },
    "popup": {
      "iconOn": "fa fa-circle fa-fw"
    },
    "twoFactorMethodRadio": {
      "iconOn": "fa fa-circle fa-fw"
    },
    "mobileUserNavBarNested": {
      "iconOn": "fa fa-circle fa-fw"
    },
    "none": {
      "iconOn": "fa fa-circle fa-fw"
    },
    "pairing": {
      "iconOn": "fa fa-circle fa-fw"
    },
    "testradio": {
      "iconOn": "fa fa-circle fa-fw"
    }
  }
}